import React, { useState } from 'react';
import axios from 'axios';
import { Check, X, Pencil } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const brl = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

export const EditorPricingCell = ({ editor, onSaved }) => {
  const [editing, setEditing] = useState(false);
  const [isPublic, setIsPublic] = useState(Boolean(editor.plataforma_publica));
  const [valor, setValor] = useState(editor.valorAssinatura || '');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    const v = parseFloat(String(valor).replace(',', '.'));
    if (!isPublic && !(v >= 10 && v <= 300)) return alert('Para catálogo pago, informe um valor mensal entre R$ 10,00 e R$ 300,00');
    const msg = isPublic
      ? `Tornar o catálogo de "${editor.bibliotecaNome}" GRATUITO? Os leitores cadastrados passam a ler sem pagar.`
      : `Tornar o catálogo de "${editor.bibliotecaNome}" PAGO por ${brl(v)}/mês? Leitores que entraram de graça passam a precisar assinar.`;
    if (!window.confirm(msg)) return;
    setSaving(true);
    try {
      await axios.put(`${API}/admin/editors/${editor.id}/pricing`, { plataforma_publica: isPublic, valor: isPublic ? null : v },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      onSaved({ plataforma_publica: isPublic, valorAssinatura: isPublic ? editor.valorAssinatura : Math.round(v * 100) / 100 });
      setEditing(false);
    } catch (e) {
      alert(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'Erro ao salvar');
    } finally {
      setSaving(false);
    }
  };

  if (!editing) {
    return (
      <button type="button" onClick={() => setEditing(true)} data-testid={`admin-editor-pricing-${editor.id}`} title="Alterar entre gratuito e pago"
        style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem', background: 'none', border: 'none', cursor: 'pointer', padding: 0, color: editor.plataforma_publica ? '#0f766e' : 'inherit', fontWeight: editor.plataforma_publica ? 600 : 400 }}>
        {editor.plataforma_publica ? 'Gratuito' : `${brl(editor.valorAssinatura)}/mês`}
        <Pencil className="w-3 h-3" style={{ opacity: 0.5 }} />
      </button>
    );
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem', minWidth: '150px' }} data-testid={`admin-editor-pricing-editor-${editor.id}`}>
      <select value={isPublic ? 'free' : 'paid'} onChange={(e) => setIsPublic(e.target.value === 'free')} data-testid={`admin-editor-pricing-type-${editor.id}`}
        style={{ padding: '0.3rem', borderRadius: 6, border: '1px solid #e2e8f0', fontSize: '0.85rem' }}>
        <option value="paid">Pago</option>
        <option value="free">Gratuito</option>
      </select>
      {!isPublic && (
        <input type="number" min="10" max="300" step="0.01" value={valor} onChange={(e) => setValor(e.target.value)} placeholder="R$ / mês"
          data-testid={`admin-editor-pricing-value-${editor.id}`} style={{ padding: '0.3rem', borderRadius: 6, border: '1px solid #e2e8f0', fontSize: '0.85rem', width: '100%' }} />
      )}
      <div style={{ display: 'flex', gap: '0.25rem' }}>
        <button type="button" onClick={save} disabled={saving} data-testid={`admin-editor-pricing-save-${editor.id}`}
          style={{ flex: 1, background: '#14b8a6', color: 'white', border: 'none', borderRadius: 6, padding: '0.25rem', cursor: 'pointer' }}><Check className="w-4 h-4" style={{ margin: '0 auto' }} /></button>
        <button type="button" onClick={() => setEditing(false)} data-testid={`admin-editor-pricing-cancel-${editor.id}`}
          style={{ flex: 1, background: '#e2e8f0', border: 'none', borderRadius: 6, padding: '0.25rem', cursor: 'pointer' }}><X className="w-4 h-4" style={{ margin: '0 auto' }} /></button>
      </div>
    </div>
  );
};
